import { useState, useEffect } from 'react'

/**
 * Feature List Editor Component
 * Benutzerfreundlicher Editor für Feature-Listen statt rohem JSON
 */
export default function FeatureListEditor({ value, onChange }) {
  const [features, setFeatures] = useState([])

  useEffect(() => {
    // Parse JSON string to array
    try {
      const parsed = JSON.parse(value || '[]')
      setFeatures(Array.isArray(parsed) ? parsed : [])
    } catch {
      setFeatures([])
    }
  }, [value])

  const updateFeatures = (newFeatures) => {
    setFeatures(newFeatures)
    // Convert back to JSON string
    onChange(JSON.stringify(newFeatures))
  }

  const addFeature = () => {
    updateFeatures([...features, ''])
  }

  const removeFeature = (index) => {
    const newFeatures = features.filter((_, i) => i !== index)
    updateFeatures(newFeatures)
  }

  const updateFeature = (index, value) => {
    const newFeatures = [...features]
    newFeatures[index] = value
    updateFeatures(newFeatures)
  }

  const moveFeature = (index, direction) => {
    const newIndex = direction === 'up' ? index - 1 : index + 1
    if (newIndex < 0 || newIndex >= features.length) return

    const newFeatures = [...features]
    ;[newFeatures[index], newFeatures[newIndex]] = [newFeatures[newIndex], newFeatures[index]]
    updateFeatures(newFeatures)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {features.map((feature, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <button
              type="button"
              onClick={() => moveFeature(index, 'up')}
              disabled={index === 0}
              className="wc-btn wc-btn-ghost"
              style={{ padding: '0 4px', minHeight: 0, fontSize: 11, lineHeight: 1 }}
              title="Nach oben"
            >
              ▲
            </button>
            <button
              type="button"
              onClick={() => moveFeature(index, 'down')}
              disabled={index === features.length - 1}
              className="wc-btn wc-btn-ghost"
              style={{ padding: '0 4px', minHeight: 0, fontSize: 11, lineHeight: 1 }}
              title="Nach unten"
            >
              ▼
            </button>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--wc-accent)', flexShrink: 0 }} aria-hidden="true">
              <path d="M5 13l4 4L19 7" />
            </svg>
            <input
              type="text"
              value={feature}
              onChange={(e) => updateFeature(index, e.target.value)}
              className="wc-input"
              style={{ flex: 1 }}
              placeholder="z.B. 1 Admin"
            />
            <button
              type="button"
              onClick={() => removeFeature(index)}
              className="wc-btn wc-btn-icon wc-btn-ghost"
              style={{ color: '#fca5a5' }}
              title="Entfernen"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={addFeature}
        className="wc-btn wc-btn-secondary wc-btn-block"
        style={{ borderStyle: 'dashed' }}
      >
        + Feature hinzufügen
      </button>

      {features.length === 0 && (
        <p className="wc-muted" style={{ fontSize: 13, textAlign: 'center', padding: '16px 0', margin: 0 }}>
          Noch keine Features hinzugefügt. Klicke auf "+ Feature hinzufügen"
        </p>
      )}
    </div>
  )
}
